// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2l6gn","colCheckbox":"styles_colCheckbox__3gDQG"};